// Loaded by the entry chunk, before Module Federation's shared scope exists. This file must have no
// imports at all (enforced by lint), so nothing can pull a shared package in ahead of time.

/**
 * Prefix oidc-client-ts gives every key it writes to localStorage: the signed-in user
 * (`oidc.user:<authority>:<client_id>`) and one `oidc.<state>` entry per sign-in request.
 */
export const oidcStorageKeyPrefix = "oidc.";

/** `request_type` oidc-client-ts stores on the state of a silent (hidden iframe) sign-in. */
export const silentSigninRequestType = "si:s";

/**
 * Paths of every `redirect_uri` the shell registers (`/?login=v1`, `/?login=v2` and the public
 * events test page). Sign-in responses, including the silent renew iframe's, only land on these.
 */
export const signinCallbackPathnames = ["/", "/internal/public-users-testing"];
